import { ModalOtrosProductosDto } from './../../feature/monitoreo/data/ModalOtrosProductosDto';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { InformacionFiltroNumeroMasJugadoDto } from '../../feature/monitoreo/data/InformacionFiltroNumeroMasJugadoDto';
import { InformacionFiltroDetalleSucursalesDto } from '../../feature/monitoreo/data/InformacionFiltroDetalleSucursalesDto';
import { InformacionFiltroMensajeriaDto } from '../../feature/monitoreo/data/InformacionFiltroMensajeriaDto';
import { ModalBalanceOtrosProductosDto } from 'src/app/feature/monitoreo/data/ModalBalanceOtrosProductosDto';
import { OpcionesPerfilRolDto } from '../data/OpcionesPerfilRolDto';
import { IRifa } from 'src/app/feature/rifas/sorteo/data/Modelos/ISorteo';
import { GenericDto } from '../data/GenericDto';

@Injectable({
  providedIn: 'root'
})
export class SubjectsService {

  public visibleSidebar$ = new BehaviorSubject<boolean>(false);
  public visibleSidebarLogin$ = new BehaviorSubject<boolean>(false);
  public hideSidebarNavbar$ = new BehaviorSubject<boolean>(false);
  public visibleSidebarInicio$ = new BehaviorSubject<any>(false);
  public moveIconNav$ = new BehaviorSubject<any>(false);
  public iconSidebar$ = new BehaviorSubject<any>(false);
  public resolucionPantallaApp$ = new BehaviorSubject<number>(0);
  public aperturoFiltroMovil$ = new BehaviorSubject<boolean>(false);
  public actualizarDatosNumeroMasJugados = new BehaviorSubject<boolean>(true);
  public actualizarDatosDetalleSucursales = new BehaviorSubject<boolean>(true);
  public fechaFiltrar = new BehaviorSubject<string>('');
  public informacionFiltrar = new BehaviorSubject<string>('');
  public habilitarBotonMarcarMensajesLeidos = new BehaviorSubject<boolean>(false);
  public llamarFuncionCantidadMensajes = new BehaviorSubject<boolean>(false);
  public esFechaActual = new BehaviorSubject<boolean>(false);
  public filtrosMonitoreo = new BehaviorSubject<InformacionFiltroNumeroMasJugadoDto>({});
  public filtrosRifas = new BehaviorSubject<IRifa>({});
  public filtrosSucursales = new BehaviorSubject<InformacionFiltroDetalleSucursalesDto>({});
  public informacionDataParaMensajeria = new BehaviorSubject<InformacionFiltroMensajeriaDto>({});
  public informacionModalBalanceOtrosProductos = new BehaviorSubject<ModalBalanceOtrosProductosDto>({});
  public informacionModalOtrosProductos = new BehaviorSubject([]);
  public base64Excel = new BehaviorSubject<string>('');
  public esVisibleReportePdf = new BehaviorSubject<boolean>(false);
  public esVisiblePorRedireccion = new BehaviorSubject<boolean>(false);
  public datosRolUsuario = new BehaviorSubject<OpcionesPerfilRolDto>({});
  public pathVistaToSideBar$ = new BehaviorSubject<string>('');
  public pathTituloInformativo$ = new BehaviorSubject<string>('');
  public visualizadorPdf = new BehaviorSubject({});
  public noInfoDetalleSucursales = new Subject<boolean>();
  public obtenerNombre = new Subject<void>();

  constructor() { }

  // COM Sidebar.
  public set listadoRecursosAsideData(visibleSidebar: boolean) {
    this.visibleSidebar$.next(visibleSidebar);
  }

  public get listadoRecursosAside(): Observable<boolean> {
    return this.visibleSidebar$.asObservable();
  }
  // COM Sidebar oculto en el login
  public set ocultarSidebarLoginSet(visibleSidebarLogin: boolean) {
    this.visibleSidebarLogin$.next(visibleSidebarLogin);
  }

  public get ocultarSidebarLoginGet(): Observable<boolean> {
    return this.visibleSidebarLogin$.asObservable();
  }

  // COM Validar que sidebar y nabar no se oculte con la redireccion lodgeado desde reportes php
  public set hideSidebarNavbarSet(hideSidebarNavbar: boolean) {
    this.hideSidebarNavbar$.next(hideSidebarNavbar);
  }

  public get hideSidebarNavbarGet(): Observable<boolean> {
    return this.hideSidebarNavbar$.asObservable();
  }
  // COM Sidebar oculto en el inicio
  public set ocultarSidebarInicioSet(visibleSidebarInicio: any) {
    this.visibleSidebarInicio$.next(visibleSidebarInicio);
  }

  public get ocultarSidebarInicioGet(): Observable<any> {
    return this.visibleSidebarInicio$.asObservable();
  }
  // COM Mover icono navbar
  public set moveIconNavSet(moveIconNav: any) {
    this.moveIconNav$.next(moveIconNav);
  }

  public get moveIconNavGet(): Observable<any> {
    return this.moveIconNav$.asObservable();
  }
  // COM Icon sidebar
  public set iconSidebarSet(iconSidebar: any) {
    this.iconSidebar$.next(iconSidebar);
  }

  public get iconSidebarGet(): Observable<any> {
    return this.iconSidebar$.asObservable();
  }
  // COM Resize.
  public set resolucionPantallaData(resolucionPantallaApp: number) {
    this.resolucionPantallaApp$.next(resolucionPantallaApp);
  }

  public get resolucionPantalla(): Observable<number> {
    return this.resolucionPantallaApp$.asObservable();
  }

  // COM Visible filtros Monitoreo.
  public set aperturoFiltroMovilData(aperturoFiltro: boolean) {
    this.aperturoFiltroMovil$.next(aperturoFiltro);
  }

  public get aperturoFiltroMovil(): Observable<boolean> {
    return this.aperturoFiltroMovil$.asObservable();
  }

  // COM Actualizar datos Numeros mas Jugados.
  public set actualizarDatosData(actualizarDatosNumeroMasJugados: boolean) {
    this.actualizarDatosNumeroMasJugados.next(actualizarDatosNumeroMasJugados);
  }

  public get actualizarDatos(): Observable<boolean> {
    return this.actualizarDatosNumeroMasJugados.asObservable();
  }

  // COM Actualizar datos Detalle sucursales.
  public get actualizaDetalleSucursales(): Observable<boolean> {
    return this.actualizarDatosDetalleSucursales.asObservable();
  }

  // COM Actualizar Fecha Filtro.
  public set fechaFiltrarSet(actualizarHoraFiltro: string) {
    this.fechaFiltrar.next(actualizarHoraFiltro);
  }

  public get fechaFiltrarGet(): Observable<string> {
    return this.fechaFiltrar.asObservable();
  }

  // COM Informacion filtros.
  public set informacionFiltroBuscarSet(informacionFiltro: string) {
    this.informacionFiltrar.next(informacionFiltro);
  }

  public get informacionFiltroBuscarGet(): Observable<string> {
    return this.informacionFiltrar.asObservable();
  }

  // COM Habilitar o no el boton de marcar todos como leidos (Tabla mensajeria).
  public set habilitarBotonMarcarMensajesLeidosSet(habilitar: boolean) {
    this.habilitarBotonMarcarMensajesLeidos.next(habilitar);
  }

  public get habilitarBotonMarcarMensajesLeidosGet(): Observable<boolean> {
    return this.habilitarBotonMarcarMensajesLeidos.asObservable();
  }

  // COM Llamar funcion de navbar desde otro componente.
  public set llamarFuncionCantidadMensajesSet(llamar: boolean) {
    this.llamarFuncionCantidadMensajes.next(llamar);
  }

  public get llamarFuncionCantidadMensajesGet(): Observable<boolean> {
    return this.llamarFuncionCantidadMensajes.asObservable();
  }

  // COM Validar si la fecha es actual
  public set esFechaActualSet(esFechaActual: boolean) {
    this.esFechaActual.next(esFechaActual);
  }

  public get esFechaActualGet(): Observable<boolean> {
    return this.esFechaActual.asObservable();
  }

  // COM Almacenar filtros monitoreo
  public set filtrosMonitoreoSet(filtrosMonitoreo: InformacionFiltroNumeroMasJugadoDto) {
    this.filtrosMonitoreo.next(filtrosMonitoreo);
  }

  public get filtrosMonitoreoGet(): Observable<InformacionFiltroNumeroMasJugadoDto> {
    return this.filtrosMonitoreo.asObservable();
  }

  // COM Pasa info a filtros mensajeria
  public set informacionDataParaMensajeriaSet(filtrosSucursales: InformacionFiltroMensajeriaDto) {
    this.informacionDataParaMensajeria.next(filtrosSucursales);
  }

  public get informacionDataParaMensajeriaGet(): Observable<InformacionFiltroMensajeriaDto> {
    return this.informacionDataParaMensajeria.asObservable();
  }

  // COM Pasa info modal balance otros productos
  public set informacionModalBalanceOtrosProductosSet(filtrosSucursales: ModalBalanceOtrosProductosDto) {
    this.informacionModalBalanceOtrosProductos.next(filtrosSucursales);
  }

  public get informacionModalBalanceOtrosProductosGet(): Observable<ModalBalanceOtrosProductosDto> {
    return this.informacionModalBalanceOtrosProductos.asObservable();
  }

  // COM Pasa info modalotros productos
  public set informacionModalOtrosProductosSet(filtrosSucursales: ModalOtrosProductosDto[]) {
    this.informacionModalOtrosProductos.next(filtrosSucursales);
  }

  public get informacionModalOtrosProductosGet(): Observable<ModalOtrosProductosDto[]> {
    return this.informacionModalOtrosProductos.asObservable();
  }

  // COM Base 64 download excel
  public set base64ExcelSet(base64: string) {
    this.base64Excel.next(base64);
  }

  public get base64ExcelGet(): Observable<string> {
    return this.base64Excel.asObservable();
  }

  // COM Visible filtros Monitoreo.
  public set esVisibleReportePdfData(esVisibleReportePdf: boolean) {
    this.esVisibleReportePdf.next(esVisibleReportePdf);
  }

  public get esVisibleReportePdfGet(): Observable<boolean> {
    return this.esVisibleReportePdf.asObservable();
  }

  // COM Validacion de visualización de vista login por redirección Caribbean.
  public set esVisiblePorRedireccionData(esVisiblePorRedireccion: boolean) {
    this.esVisiblePorRedireccion.next(esVisiblePorRedireccion);
  }

  public get esVisiblePorRedireccionGet(): Observable<boolean> {
    return this.esVisiblePorRedireccion.asObservable();
  }

  //COM capturar rol para el sidebar
  public set datosRolUsuarioSet(datosRolUsuario: OpcionesPerfilRolDto) {
    this.datosRolUsuario.next(datosRolUsuario);
  }

  public get datosRolUsuarioGet() {
    return this.datosRolUsuario.asObservable();
  }

  // COM Actualizar Fecha Filtro.
  public set pathVistaToSideBarSet(pathVistaToSideBar: string) {
    this.pathVistaToSideBar$.next(pathVistaToSideBar);
  }

  public get pathVistaToSideBarGet(): Observable<string> {
    return this.pathVistaToSideBar$.asObservable();
  }

  // COM Opcion de titulo informativo
  public set pathTituloInformativoSet(pathTituloInformativo: string) {
    this.pathTituloInformativo$.next(pathTituloInformativo);
  }

  public get pathTituloInformativoGet(): Observable<string> {
    return this.pathTituloInformativo$.asObservable();
  }

  // COM filtros de Rifas
  public set filtrosRifasSet(filtrosRifas: IRifa) {
    this.filtrosRifas.next(filtrosRifas);
  }

  public get filtrosRifasGet(): Observable<IRifa> {
    return this.filtrosRifas.asObservable();
  }

  // COM Visualizador Pdf
  public set visualizadorPdfSet(visualizadorPdf: any) {
    this.visualizadorPdf.next(visualizadorPdf);
  }

  public get visualizadorPdfGet(): Observable<any>{
    return this.visualizadorPdf.asObservable();
  }

  // COM Error al no encontrar detalles sucursales
  public emitirDetalleSucursales() {
    this.noInfoDetalleSucursales.next(true);
  }

  public detalleSucursalesObservable(): Observable<boolean> {
    return this.noInfoDetalleSucursales.asObservable();
  }

  //  COM Ejecutar funcion para obtener nombre de usuario en el navvbar despues de logueado
  obtenerNombrefuncion(): void {
    this.obtenerNombre.next();
  }

  onObtenerNombrefuncion(): Observable<void> {
    return this.obtenerNombre.asObservable();
  }
}
